import { render, staticRenderFns } from "./MenuLogout.vue?vue&type=template&id=57a4d6b8&"
import script from "./MenuLogout.vue?vue&type=script&lang=js&"
export * from "./MenuLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports